import { put, call, take, fork } from 'redux-saga/effects'
import { assignmentEditService } from '../../api/assignment'
import { assignmentEditSuccess } from '../../reducers/assignment/action'
import { ASSIGNMENT_EDIT } from '../../reducers/assignment/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* assignmentEditFlow(payload) {
  try {
    const { entity, callback } = payload
    const response = yield call(assignmentEditService, entity)

    yield put(assignmentEditSuccess(response.data))
    yield put(operationSuccess())
    callback()

  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* assignmentEditWatcher() {
  while (true) {
    const action = yield take(ASSIGNMENT_EDIT)
    const { payload } = action

    yield fork(generalSaga, assignmentEditFlow, payload)
  }
}
